<template>
    <div>
        <Loading :value="loading" ></Loading>
        <v-layout row >
            <v-flex sm12 ml-1 mr-1 mt-1>
                <v-card>
                    <el-tabs  v-model="onglet" type="border-card" @tab-click="handleTabClick" >
                        <el-tab-pane label="Dashboard RH">
                            <boardResource></boardResource>
                        </el-tab-pane>

                        <!--reserve aux employes-->
                        <!--<el-tab-pane label="Informations & congés">-->
                            <!--&lt;!&ndash;Detail employe&ndash;&gt;-->
                            <!--<detailEmploye :showEmpl="showDetailEmpl" :idUserCont="idEmploye" ></detailEmploye>-->
                        <!--</el-tab-pane>-->


                        <!--reserve aux employes-->

                        <!--reserve aux RH-->
                        <el-tab-pane  label="Liste contrats">
                            <listeContrat @clickDetCont="showDetailCont" ></listeContrat>
                        </el-tab-pane>

                        <el-tab-pane label="Liste demandes en attente">
                            <listeDemande></listeDemande>
                        </el-tab-pane>

                        <el-tab-pane  label="Liste employés">

                            <listeEmploye></listeEmploye>


                        </el-tab-pane>
                        <!--reserve aux RH-->
                    </el-tabs>
                </v-card>
            </v-flex>
        </v-layout>

    </div>
</template>

<script>
    import Loading from '@/components/Loading';
    import boardResource  from "@/components/resourceHumaine/board_resource"
    import listeEmploye  from "@/components/resourceHumaine/liste_employe"
    import detailEmploye  from "@/components/resourceHumaine/detail_employe"
    import listeContrat  from "@/components/resourceHumaine/liste_contrat"
    import listeDemande  from "@/components/resourceHumaine/liste_demande"

    export default {
        components: {Loading, boardResource,listeEmploye,detailEmploye,listeContrat,listeDemande},
        name: "indexResource",
        data(){
            return {
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                loading: false,

                onglet: "0",
                showDetailEmpl:false,
                idEmploye: null,
                showListeEmploye: false

            }
        },
        methods:{
            handleTabClick(tab,action)
            {
                //this.showDetailEmpl = false;
                this.showListeEmploye = false;
                switch(this.onglet){
                    case "0":

                        break;

                    case "1":

                        break;
                    case "2":

                        break;

                    case "3": //listes employes
                        this.showListeEmploye = true;
                        break;

                }
            },

            showDetailCont(idEmp){
                this.idEmploye = idEmp;
                this.onglet = "1";
            }
        },
        mounted(){
            this.idEmploye = this.user.id;
        }
    }

</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/resourceHumaine/index_resource.vue